// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"9cb680d7","453":"d90b07f6"}[chunkId] + ".chunk.js";
};